// extracted by mini-css-extract-plugin
module.exports = {"spin":"Svg_spin__2XPq7","rotate":"Svg_rotate__1BVNb","svg":"Svg_svg__1KS2d"};